import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { isAuthenticated } from './service/Auth/Auth.js';
import Login from './screens/Login/Login.jsx';
import Layout from './components/navigation/Layout.jsx';
import Dashboard from './screens/Dashboard/Dashboard.jsx';
import Contacts from './screens/Contacts/Contacts.jsx';
import ContactAdd from './screens/Contacts/ContactAdd.jsx';
import ContactEdit from './screens/Contacts/ContactEdit.jsx';
import Listings from './screens/Listings/Listings.jsx';
import ListingAdd from './screens/Listings/ListingAdd.jsx';
import ListingEdit from './screens/Listings/ListingEdit.jsx';
import OFI from './screens/OFI/OFI.jsx';
import OFIAdd from './screens/OFI/OFIAdd.jsx';
import FeedbackAdd from './screens/Listings/FeedbackAdd.jsx';
import Actions from './screens/Actions/Actions.jsx';
import ActionView from './screens/Actions/ActionView.jsx';
import ActionAdd from './screens/Actions/ActionAdd.jsx';
import OFITopTabs from './screens/OFI/OFItopTabs.jsx';
import EmailBuilder from './screens/Broadcasting/BroadcastingGrape.jsx'
import AppraisalView from './screens/Appraisal/AppraisalView.jsx';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    setIsAuth(isAuthenticated());
  }, []);

  if (isAuth === null) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return isAuth ? children : <Navigate to="/login" replace />;
};

// Public Route component (redirects to dashboard if already authenticated)
const PublicRoute = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    setIsAuth(isAuthenticated());
  }, []);

  if (isAuth === null) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return !isAuth ? children : <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />

        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          
          {/* Contacts routes */}
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/add" element={<ContactAdd />} />
          <Route path="contacts/:contactId/edit" element={<ContactEdit />} />
          
          {/* Listings routes */}
          <Route path="listings" element={<Listings />} />
          <Route path="listings/add" element={<ListingAdd />} />
          <Route path="listings/:propertyId/listingedit" element={<ListingEdit />} />
          
          {/* OFI routes */}
          <Route path="ofi" element={<OFI />} />
          <Route path="ofi/add" element={<OFIAdd />} />
          <Route path="ofi/ofiapp" element={<OFITopTabs />} />


           {/* Feedback routes */}
          <Route path="feedback/add" element={<FeedbackAdd />} />

          <Route path="broadcasting" element={<EmailBuilder />} />
          
          <Route path="appraisal" element={<AppraisalView />} />
          {/* Actions routes */}
          <Route path="actions" element={<Actions />} />
          <Route path="actions/add" element={<ActionAdd />} />
          <Route path="actions/:actionId" element={<ActionView />} />
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
